import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { Row, Col, UncontrolledPopover, PopoverHeader, PopoverBody, Button } from 'reactstrap';
import * as commonFunc from 'scripts/common';

import Swal from "sweetalert2";
import sanitizeHtml from 'sanitize-html';

import { useTranslation } from "react-i18next";

import { withRouter } from 'components/withRouter';

class ShowSession extends Component {
    static displayName = ShowSession.name;

    constructor(props) {
        super(props);

        this.state = { };
    }

    componentDidMount() {
        //console.debug("mount");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function () {
            //TODO init
        });

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.searchParams !== prevProps.searchParams) {
            this.getContent();
        }
    }

    render() {

        var rowData = { "AdditionnalInfos": { "ID": -1, "Name": "Canyon du Rieusset", "Title": "<p>Un canyon de printemps magnifique à deux pas de Vallon Pont d'Arc. Une très belle sortie à quelques minutes du Pont d'Arc. Ce petit bijou est rarement réalisable, profitez en lorsqu'il est en condition !</p>", "Description": "<p>Après une marche d'approche bucolique, le canyon révèle petit à petit ses méandres, ressauts et arche. Vous franchirez ces différents obstacles à l'aide de tyrolienne, rappels et mains courantes. Sauts non obligatoires seront aussi au rdv.</p>", "Language": "", "ActID": 0, "IsFront": false, "DifficultyInfo": "", "JumpInfo": "", "CompInfo": "", "Notice": "", "StrongPoints": "", "GuideName": "", "GuideDesc": "", "GuideComments": "", "SpecialPrice": "", "SpecialPriceDesc": "", "LengthDesc": "", "MatUseCase": "", "MatRange": "", "MatAutomous": "", "MatTours": "", "MatFeatures": "", "MatPeriods": "", "MatCompInfo": "" }, "IsFavorite": false, "IsNovelty": false, "CatID": 0, "CatName": "ACT", "Constraints": { "ID": 2342, "Title": "Printemps - été - Automne", "Description": "", "StartDate": "0001-01-01T00:00:00", "EndDate": "9999-12-31T23:59:59.9999999", "IsOpened": false, "BenDifficulty": 0, "BenSportivity": 0, "BenTechnicity": 0, "BenMinPax": 0, "BenForbidDays": 0, "BenForbidSpecDays": true, "CliMinPax": 1, "CliMinAge": 7, "CliPhysCond": 0, "CliExpCond": 0, "CliNatCond": 1, "CliVertigoCond": 0, "CliClaustroCond": 0, "CliMinImc": 0, "CliMaxImc": 0, "SessionCeiling": -1, "ActID": 0, "SiteID": 0, "Active": true, "DateSysMod": "0001-01-01T00:00:00" }, "CItems": null, "COptions": null, "CBenefits": null, "CRdvPoints": [{ "RdvPoint": { "ID": 359, "Score": 0, "MatchSrc": "SALAVAS", "PrecisionSrc": "", "GeoSrc": 2, "Name": "Pt RDV Foussoubie", "Confirmed": true, "UserID": -1, "DateSysMod": "0001-01-01T00:00:00", "Geo_Lat": "44,3945422", "Geo_Lon": "4,3785706" }, "Access": "", "Lang": "", "ActID": 21, "AdID": 34, "HourAM": "08:45:00", "HourPM": "13:45:00", "HourNI": "00:00:00", "DisplayIndex": 0, "Categ": "ACT" }], "CCycles": null, "CAgesBrackets": null, "Filter": null, "DiffDays": 0.53125, "ID": 32764, "CPrices": [{ "ID": 9935, "Name": "1.Indiv Printemps", "PriceA": 54, "PriceC": 54, "PriceS": -1, "PriceG": -1, "PriceE": -1, "ActID": 21, "ParentID": 0, "IsOption": false, "StartDate": "0001-01-01T00:00:00", "EndDate": "0001-01-01T00:00:00", "PriceAP": 52, "PriceCP": 52, "PriceSP": 0, "PriceGP": -1, "PriceGFrom": 0, "PriceGTo": 0, "PriceIFrom": 1, "PriceITo": 7, "Categ": "ACT", "AgeBrackID": 2, "SiteID": 7150, "Active": true, "DateSysMod": "2026-02-03T17:54:53", "MatchingsCount": 3, "DaysDelayCount": 74, "Conditions": [{ "ID": -1, "MinPax": 1, "MaxPax": 1, "GroupMode": 0, "StartDate": "2026-03-16T14:47:51.1250489+01:00", "EndDate": "2026-03-20T23:59:59", "IsPromotion": false, "IsGoodPlan": false, "EligibledDays": 254, "EligibleSpecDays": true, "CycleID": 0, "PriceID": 0, "Active": true, "DateSysMod": "0001-01-01T00:00:00", "Keys": null }], "Benefits": null, "TargetIDs": null, "PriceTypeID": 0 }, { "ID": 9938, "Name": "Association", "PriceA": -1, "PriceC": -1, "PriceS": -1, "PriceG": -1, "PriceE": 380, "ActID": 21, "ParentID": 0, "IsOption": false, "StartDate": "0001-01-01T00:00:00", "EndDate": "0001-01-01T00:00:00", "PriceAP": -1, "PriceCP": -1, "PriceSP": 0, "PriceGP": -1, "PriceGFrom": 0, "PriceGTo": 0, "PriceIFrom": 1, "PriceITo": 7, "Categ": "ACT", "AgeBrackID": 2, "SiteID": 7150, "Active": true, "DateSysMod": "2025-11-14T09:53:42", "MatchingsCount": 3, "DaysDelayCount": 74, "Conditions": [{ "ID": -1, "MinPax": 1, "MaxPax": 1, "GroupMode": 0, "StartDate": "2026-03-16T14:47:51.1250489+01:00", "EndDate": "2026-03-20T23:59:59", "IsPromotion": false, "IsGoodPlan": false, "EligibledDays": 254, "EligibleSpecDays": true, "CycleID": 0, "PriceID": 0, "Active": true, "DateSysMod": "0001-01-01T00:00:00", "Keys": null }], "Benefits": null, "TargetIDs": null, "PriceTypeID": 0 }, { "ID": 480, "Name": "4.Engagement Privé", "PriceA": -1, "PriceC": -1, "PriceS": -1, "PriceG": -1, "PriceE": 360, "ActID": 21, "ParentID": 0, "IsOption": false, "StartDate": "0001-01-01T00:00:00", "EndDate": "0001-01-01T00:00:00", "PriceAP": -1, "PriceCP": -1, "PriceSP": 0, "PriceGP": -1, "PriceGFrom": 0, "PriceGTo": 0, "PriceIFrom": 1, "PriceITo": 4, "Categ": "ACT", "AgeBrackID": 2, "SiteID": 7150, "Active": true, "DateSysMod": "2018-02-20T15:27:36", "MatchingsCount": 3, "DaysDelayCount": 2996, "Conditions": [{ "ID": -1, "MinPax": 1, "MaxPax": 1, "GroupMode": 0, "StartDate": "2026-03-16T14:47:51.1250489+01:00", "EndDate": "2026-03-20T23:59:59", "IsPromotion": false, "IsGoodPlan": false, "EligibledDays": 254, "EligibleSpecDays": true, "CycleID": 0, "PriceID": 0, "Active": true, "DateSysMod": "0001-01-01T00:00:00", "Keys": null }], "Benefits": null, "TargetIDs": null, "PriceTypeID": 0 }], "IsDefault": false, "StartDate": "2026-03-17T13:45:00", "EndDate": "2026-03-17T17:15:00", "ActLength": 0, "TypeActID": 5, "TypeActName": "Canyoning", "ActID": 21, "CountPax": 0, "Occupation": 0, "MaxPax": 10, "Scoring": 100, "ResourceID": -1, "ResName": "Canyon du Rieusset", "ResInfo": "", "ResAvatar": "../api/ApiSync/DownloadPublicFile?fileID=236409&filetypeID=0&bindID=21&newWindow=false", "CycleName": "Demi-Journée", "CycleID": 2, "SubCycleName": "<span>Après-Midi</span>", "CyclePriceName": "Demi-Journée", "CyclePriceID": 2, "Status": 301, "StatusName": "", "IsConfirmed": false, "OnlineBooking": true };

        var styleComp = <style>
            {`
                .header-act {
                    height: 100vh;
                    max-height: calc(100vh - 158px - 2vw * 2);
                }
                .top-background-img {
                    max-width: 100vw;
                    max-height: calc(100vw * 1100 / 2000);
                    place-content: center;
                    overflow: clip;

                    position: relative;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .top-background-img:after {
                    content: '';
                    position: absolute;
                    z-index: 0;
                    top: 0;
                    right: 0;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(to right, rgba(33, 33, 33, 0) 0%, rgba(33, 33, 33, 0.7) 100%);
                }

                .title-act {
                    font-size: 8vh;
                    text-tranform: uppercase;
                    line-height: 8vh;
                    letter-spacing: 4px;
                }

                .description-act {
                    position: absolute;
                    z-index: 5;
                    top: 0;
                    right: 0;
                    width: calc(100% - 3vw * 2);
                    height: calc(100% - 14vw);
                    max-width: 550px;
                    margin: 7vw 3vw 3vw 3vw;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }
                .back-search {
                    position: absolute;
                    z-index: 90;
                    top: 250px;
                    left: 50px;
                    bottom: unset;
                    margin-top: 0;
                    cursor: pointer;
                }
            `}
        </style>;


        var desc = sanitizeHtml(rowData.AdditionnalInfos?.Title, {
            allowedTags: [],
            allowedAttributes: {}
        });

        return <div id="show-session">
            {styleComp}
            <NavLink to={`/SearchSessions`} className="nav-link">
                <Button className="back-search" color="danger" style={{ backgroundColor: "#00AAA8", borderRadius: "25px" }} onClick={() => { }}>Revenir à la recherche</Button>
            </NavLink>
            <div className="header-act">
                <div class="top-background-img d-flex text-center">
                    <img className="float-start" style={{ width: "100%" }} src={rowData.ResAvatar.replace("../api/ApiSync/DownloadPublicFile", "https://facesud.softena.com/Booking/DownloadFile")} alt="Avatar" />
                    <div className="description-act text-white">
                        <h6 className="m-0" style={{ color: "#00AAA8" }}>{rowData.TypeActName}</h6>
                        <div className="title-act">{rowData.AdditionnalInfos?.Name}</div>
                        <div className="price-part d-flex align-items-center">
                            <div className="text-start">
                                <h6 className="m-0">à partir de</h6>
                                <div style={{ fontSize: "11px", opacity: "0.7" }}>prix TTC/pers</div>
                            </div>
                            <div style={{ color: "#00AAA8" }}><span className="fw-bold ms-3" style={{ fontSize: "50px" }}>{rowData.CPrices[0].PriceA} €</span></div>
                        </div>
                        <div className="text-start fs-6">{desc}</div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ShowSession));